var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "my-md-n10px"
  }, [_c('v-row', _vm._l(_vm.giftcards, function (giftcard) {
    return _c('v-col', {
      key: giftcard._id,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "py-md-10px"
    }, [_c('div', {
      staticClass: "border"
    }, [_c('v-img', {
      attrs: {
        "src": "https://salerbookcash.com" + giftcard.thumb,
        "max-width": "500",
        "aspect-ratio": 500 / 500,
        "contain": ""
      }
    })], 1), _c('div', {
      staticClass: "text-center py-12px py-md-16px"
    }, [_c('div', {
      staticClass: "tit tit--xs text-truncate"
    }, [_vm._v(_vm._s(giftcard.name))]), _c('div', {
      staticClass: "font-size-16 font-size-md-18 mt-6px"
    }, [_c('b', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(giftcard.faceamt.format()))]), _vm._v(" 원")])]), _c('div', [_c('v-btn', {
      attrs: {
        "large": "",
        "block": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.order(giftcard);
        }
      }
    }, [_vm._v("구매하기")])], 1)])]);
  }), 1)], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "color": "primary",
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('giftcard-dialog', {
    ref: "giftcardDialog"
  }), _c('login-dialog', {
    ref: "loginDialog"
  }), _c('kcb-cert', {
    ref: "kcbCert"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }